// extracted by mini-css-extract-plugin
export default {"root":"steps-module___root___b6650e3a","step":"steps-module___step___f80fc61c","light":"steps-module___light___c18991a4"};